import AnchorJS from 'anchor-js'
import toc from './toc'
// Font Awesome is now loaded via CSS CDN in base-head.ejs for better performance

const init = function () {
  // Wait for jQuery to be available
  function waitForJQuery(callback) {
    if (typeof window.$ !== 'undefined' && window.$ !== null) {
      callback()
    } else {
      setTimeout(() => waitForJQuery(callback), 50)
    }
  }

  // Function to execute after jQuery is loaded
  function executeAfterJQueryReady() {
    // Remove site intro image placeholder
    const $introImg = $('.site-intro-img:first')
    const $introPlaceholder = $('.site-intro-placeholder:first')
    
    if ($introImg.length > 0 && $introPlaceholder.length > 0) {
      // Support both <img src="..."> and <div style="background-image: url(...)">
      let bgURL = null
      
      // Check if it's an <img> element
      if ($introImg.is('img')) {
        bgURL = $introImg.attr('src')
      } else {
        // It's a div with background-image
        const bgCSS = $introImg.css('background-image')
        const bgRegResult = bgCSS ? bgCSS.match(/url\("*([^"]*)"*\)/) : null
        if (bgRegResult && bgRegResult.length >= 2) {
          bgURL = bgRegResult[1]
        }
      }

      if (bgURL) {
        const img = new Image()

        img.onload = () => {
          $introPlaceholder.remove()
          console.info('site intro image loaded.')
        }
        img.onerror = () => {
          // Still remove placeholder on error to avoid blocking
          $introPlaceholder.remove()
          console.warn('site intro image failed to load, but continuing.')
        }
        img.src = bgURL
      } else {
        // No URL found, just remove placeholder
        $introPlaceholder.remove()
        console.warn('No site intro image URL found.')
      }
    }

    // Function to hide loading screen and show content
    function showContent() {
      $('.container').removeClass('container-unloaded')
      $('.footer').removeClass('footer-unloaded')
      $('.loading').remove()

      // Init anchors
      // https://www.bryanbraun.com/anchorjs/
      const anchors = new AnchorJS()
      anchors.options = {
        placement: 'right',
        class: 'anchorjs-archer',
      }
      anchors.add()

      // As headers' absolute offset-y can be queried properly
      // after remove container's `container-unloaded` class,
      // so we should init toc here for better performance.
      toc()
    }

    // Check if DOM is already loaded
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', showContent, false)
    } else {
      // DOM is already loaded
      showContent()
    }
  }

  // Wait for jQuery and then execute
  waitForJQuery(executeAfterJQueryReady)
}

export default init
